import ImageCompressor from '../libs/js/image-compressor.js';
import { occoApi } from './occoAPI-module.js';
import LANG from '../lang/prop_en.js';
import { alertMessagePopup, uploadFileToS3, renameFileNameMutate } from './utils-module.js';
import multiAccounts from './multiAccounts/index.ts';

function generateRandomFileName(originalFileName, { prefix = '', separator = '_', getDate = () => new Date() } = {}) {
  let fileType = '';
  if (originalFileName && originalFileName.lastIndexOf('.') !== -1) {
    fileType = originalFileName.substr(originalFileName.lastIndexOf('.') + 1);
  }
  const randomSymbols = Math.random().toString(36).substring(7);
  const prefixString = prefix ? `${prefix}${separator}` : '';

  return `${prefixString}${randomSymbols}${separator}${prepareDate()}.${fileType}`;

  function prepareDate() {
    const d = getDate();
    const yearLastDigit = d.getFullYear().toString();
    const month = (d.getMonth() + 1).toString();
    const day = d.getDate().toString();
    const hours = d.getHours().toString();
    const minutes = d.getMinutes().toString();
    const seconds = d.getSeconds().toString();
    return (
      yearLastDigit +
      separator +
      month +
      separator +
      day +
      separator +
      hours +
      separator +
      minutes +
      separator +
      seconds
    );
  }
}

export async function uploadSelfieImage(file) {
  const account = multiAccounts.getCurrentAccount();

  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('File is not defined'));
      return;
    }

    if (!/\.(jpg)$/i.test(file.name)) {
      reject(new Error(LANG.unsupported_pic_format));
      return;
    }

    // eslint-disable-next-line no-new
    new ImageCompressor(file, {
      checkOrientation: false,
      quality: 0.9,
      maxWidth: 1500,
      convertSize: Infinity,
      mimeType: 'image/jpeg',
      success(resizedFile) {
        renameFileNameMutate(resizedFile, generateRandomFileName(file.name, { prefix: 'selfie' }));
        const now = new Date();
        const selfiePath = `${account.eventCode}/${now.getFullYear()}/${now.getMonth() + 1}/${now.getDate()}/${
          resizedFile.name
        }`;

        occoApi.profilePhotoTmpUploadAccessRetrieve(selfiePath, (err, result) => {
          if (err) {
            return reject(err);
          }
          // NOTE: Maybe we can use this callback to show the image preview
          // if (opt.callbackAdd) {
          //   opt.callbackAdd(URL.createObjectURL(resizedFile));
          // }
          uploadFileToS3(resizedFile, result.fields.key, result.url, result.fields, (imgPath) => {
            occoApi.createProfilePhoto(account.attendeeUid, imgPath, account.eventCode, (e) => {
              if (e) {
                return reject(e);
              }
              resolve();
            });
          });
        });
      },
      error(e) {
        reject(e);
      },
    });
  });
}

export async function profilePhotoImageUpload(file, opt) {
  if (file) {
    let fileName = file.name;
    if (!/\.(gif|jpg|jpeg|mp4|png)$/i.test(fileName)) {
      alertMessagePopup(LANG.unsupported_pic_format);
      return;
    }
    if (opt.generateFileName) {
      fileName = generateRandomFileName(fileName);
    }

    let rootPath = '/';
    if (opt.fileRootPath) {
      rootPath = opt.fileRootPath;
    }
    const fileRelativePath = `${rootPath}/${fileName}`;
    new ImageCompressor(file, {
      checkOrientation: false,
      quality: 0.9,
      maxWidth: 1500,
      convertSize: Infinity,
      mimeType: 'image/jpeg',
      success(res) {
        const fileResized = res;
        occoApi.profilePhotoTmpUploadAccessRetrieve(fileRelativePath, (err, result) => {
          if (err) {
            return alert(err.message_key);
          }
          if (opt.callbackAdd) {
            opt.callbackAdd(URL.createObjectURL(fileResized));
          }
          uploadFileToS3(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
        });
      },
      error(e) {
        console.log(e.message);
      },
    });
  }
}

export function customImageUpload(file, opt) {
  const maxWidth = 2000;
  const maxHeight = 2000;
  if (file) {
    let fileName = file.name;
    let keepOriginName = false;
    if (!/\.(gif|jpg|jpeg|mp4|png)$/i.test(fileName)) {
      alertMessagePopup(LANG.unsupported_pic_format);
      return;
    }
    if (opt.generateFileName) {
      fileName = generateRandomFileName(fileName, { prefix: opt.prefixFileName });
      keepOriginName = true;
    }

    new ImageCompressor(file, {
      checkOrientation: false,
      quality: 0.9,
      maxWidth,
      maxHeight,
      convertSize: Infinity,
      mimeType: 'image/jpeg',
      success(res) {
        const fileResized = res;
        occoApi.customPhotoTmpUploadAccessRetrieve(
          opt.eventName,
          fileName,
          keepOriginName,
          opt.attendeeUid,
          (err, result) => {
            if (err) {
              return alert(err.message_key);
            }
            if (opt.callbackAdd) {
              opt.callbackAdd(URL.createObjectURL(fileResized));
            }
            uploadFileToS3(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
          }
        );
      },
      error(e) {
        console.log(e.message);
      },
    });

    /*   resizeImage(file, 1500, 1500, fileName, function (fileResized, src) {
                   occoApi.customPhotoTmpUploadAccessRetrieve(opt.eventName, fileName, function (err, result) {
                       if (err) {
                           return alert(err.message_key);
                       }
                       if (opt.callbackAdd) {
                           opt.callbackAdd(src);
                       }
                       uploadFileToS3Test(fileResized, result.fields.key, result.url, result.fields, opt.callbackSuccess);
                   });

               }); */
  }
}
